import React from "react";

import { useParams, useNavigate } from "react-router-dom";

const CorporateBookings = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center px-4 py-10 mt-20">
      <div className="p-4 max-w-xl mr-80 -ml-64 -mt-16">
         <button
        onClick={() => navigate(-1)}
        className="text-gray-600 hover:text-gray-800 hidden md:block mt-[5.5rem] mr-100"
      >
        ← Go Back
      </button>
      </div> 
      <div className="bg-white shadow-xl rounded-xl p-8 max-w-2xl w-full">
        <h1 className="text-3xl font-bold text-blue-700 mb-4 text-center">
          Corporate Bookings
        </h1>
        <p className="text-gray-700 mb-6 text-center text-sm">
          Looking to streamline transportation for your company? We offer reliable, customizable cab services for your employees, clients, and executives.
        </p>

        <div className="space-y-4 text-md text-gray-800">
         

          <p className="pt-4"><strong>Get in Touch:</strong></p>
          <p><strong>Company Name:</strong>{" "} The Great Himalayas Cab Service </p>
          <p>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:contact@thegreathimalayas.com"
              className="text-blue-500 hover:underline"
            >
              contact@thegreathimalayas.com
            </a>
          </p>
          <p>
            <strong>Phone:</strong>{" "}
            <a
              href="tel:+91 9883587965"
              className="text-blue-500 hover:underline"
            >
             +91 9883587965
            </a>
          </p>
          <p>
            <strong>Office Hours:</strong> Mon – Sat | 10:00 AM – 6:00 PM
          </p>
          <p>
            <strong>Office Address:</strong><br />
            Siliguri, Darjeling(Dist), West Bengal, 734001
          </p>
        </div>

        <p className="text-sm text-center text-gray-500 mt-8">
          Simplify your business travel with The Great Himalayas Cab Services.
        </p>
      </div>
    </div>
  );
};

export default CorporateBookings;
